import { W, fit, startCanvas, finishCanvas, loadSilks, drawSilk, ShareButtons } from "@/components/ShareButtons";
import { fmtDate, slug } from "@/lib/api";

const BADGE = { won: ["WON", "#10b981", "#0B101D"], placed: ["PLACED", "#3b82f6", "#ffffff"], unplaced: ["UNPLACED", "#334155", "#cbd5e1"] };

const badge = (ctx, outcome, x, y) => {
  const [label, bg, fg] = BADGE[outcome] || BADGE.unplaced;
  ctx.font = "800 22px 'DM Sans', sans-serif";
  const w = ctx.measureText(label).width + 28;
  ctx.fillStyle = bg; ctx.beginPath(); ctx.roundRect(x - w, y - 30, w, 40, 8); ctx.fill();
  ctx.fillStyle = fg; ctx.textAlign = "center"; ctx.fillText(label, x - w / 2, y - 2); ctx.textAlign = "left";
};

export const tally = (races) => ({
  wins: races.filter((r) => r.selections[0]?.outcome === "won").length,
  placed: races.filter((r) => ["won", "placed"].includes(r.selections[0]?.outcome)).length,
  winners: races.filter((r) => r.selections.some((s) => s.outcome === "won")).length,
});

async function drawRecord(g) {
  const races = g.races.slice(0, 10);
  const row = races.length > 7 ? 76 : 96;
  const { c, ctx } = await startCanvas(Math.max(1350, 560 + races.length * row + 140));
  const t = tally(g.races);
  ctx.fillStyle = "#60a5fa"; ctx.font = "700 30px 'DM Sans', sans-serif";
  ctx.fillText(`RESULTS · ${fmtDate(g.date).toUpperCase()}`, 72, 330);
  ctx.fillStyle = "#ffffff"; ctx.font = "900 78px Outfit, sans-serif";
  ctx.fillText(fit(ctx, g.track.toUpperCase(), W - 144), 72, 420);
  ctx.font = "800 36px Outfit, sans-serif"; ctx.fillStyle = "#fbbf24";
  ctx.fillText(`Top pick: ${t.wins} won · ${t.placed} top 3 from ${g.races.length}`, 72, 482);
  let y = 590;
  const silks = await loadSilks(races.map((r) => r.selections[0]?.silk_url));
  races.forEach((r, i) => {
    const s = r.selections[0] || {};
    if (i % 2 === 0) { ctx.fillStyle = "rgba(255,255,255,0.04)"; ctx.fillRect(48, y - row / 2 - 22, W - 96, row); }
    ctx.fillStyle = "#60a5fa"; ctx.font = "800 34px 'JetBrains Mono', monospace"; ctx.fillText(`R${r.race_number}`, 72, y);
    drawSilk(ctx, silks[i], 170, y - row / 2 - 16, row - 12);
    ctx.fillStyle = "#ffffff"; ctx.font = "800 40px Outfit, sans-serif"; ctx.fillText(fit(ctx, s.horse, W - 580), 190 + row, y);
    badge(ctx, s.outcome, W - 72, y);
    y += row;
  });
  if (g.races.length > races.length) { ctx.fillStyle = "#94a3b8"; ctx.font = "500 26px 'DM Sans', sans-serif"; ctx.fillText(`+ ${g.races.length - races.length} more races — full record online`, 72, y); }
  return finishCanvas(c, ctx, "Past results are no guarantee. 18+ · Gamble responsibly · 1800 858 858");
}

export const ShareRecordCard = ({ g }) => (
  <ShareButtons make={() => drawRecord(g)} testid={`share-record-${slug(g.track)}-${g.date}`} prefix={`record-${slug(g.track)}-${g.date}-`}
    fileName={`weekend-edge-results-${slug(g.track)}-${g.date}.png`}
    title={`${g.track} results`} text={`The Weekend Edge results: ${g.track}, ${fmtDate(g.date)}`}
    pageUrl={`${window.location.origin}/record`} />
);
